import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Observer } from "mobx-react";
import { useStores } from "../../store";
import { apiPostPut } from "../../api/api_methods";
import {
  getUserDataFromLocalStorage,
  setDataToLocalStorage,
} from "../../services/localStorage";
import { getUserRoleFromLocalStorage } from "../../services/reusable";
import { uploadFileToAzure } from "../../services/azure";
import { MdFileUpload } from "react-icons/md";
import { FaCircleNotch } from "react-icons/fa";
import { AiFillCaretDown, AiOutlineCloseCircle, AiOutlineCopy } from "react-icons/ai";
import { MdOutlineAdd } from "react-icons/md";
import { pdfjs } from "react-pdf";
import axios from "axios";
import { IoInformationCircleOutline } from "react-icons/io5";
import { FaPlus } from "react-icons/fa";
import { IoIosArrowDown, IoMdArrowRoundBack } from "react-icons/io";
import { MdDeleteOutline } from "react-icons/md";
import aiDemoIcon from "../../assests/svg/personAIDemoIcon.svg";
import BgaiDemoIcon from "../../assests/svg/bgAIDemoIcon.svg";

import {
  interviewsList,
  interviewsProList,
  loginWarningImage,
} from "../../helpers/constantVariables";


import { PurchaseCredits } from "./creditPoints";
import { GetMoreCreditsPopUp, RedeemCoupon } from "./basicDetails";
import Popup from "../reusble_components/popup";
import PreviousInterviews from "../reusble_components/popup/previousInterviews";
import InterviewSetting2 from "../interview/InterviewSetting2";

function AdditionalSettings() {
  const { InterviewStore, PopupStore } = useStores();
  const [show, setShow] = useState(false);
  return (
    <div className="flex flex-col justify-center my-4 border border-primary w-[95%] min-h-[40px] md:min-h-[45px] md:text-lg rounded-xl lg:text-xl p-2">
      <div className="flex flex-row w-full   justify-between items-center">
        <p className="text-lg ">Additional Settings</p>
        <IoIosArrowDown
          className="text-sm text-primary cursor-pointer"
          onClick={() => {
            setShow(!show);
          }}
        />
      </div>
      {show && (
        <div className="px-4">
          <span className="flex justify-between items-center">
            <span className="text-base">Video </span>
            <label className="switch">
              <input
                type="checkbox"
                onChange={(e) => {
                  InterviewStore.setAdditionalSettings(
                    "camera",
                    e.target.checked
                  );
                }}
                name="cam"
                id="cam"
              />
              <span className="slider round"></span>
            </label>
          </span>
          <span className="flex justify-between items-center">
            <span className="text-base">Resume </span>
            <label className="switch">
              <input
                type="checkbox"
                name="resume"
                id="resume"
                onChange={(e) => {
                  InterviewStore.setAdditionalSettings(
                    "resume",
                    e.target.checked
                  );
                }}
              />
              <span className="slider round"></span>
            </label>
          </span>
          <span className="flex justify-between items-center">
            <span className="text-base">Screen Recording </span>
            <label className="switch">
              <input
                type="checkbox"
                name="screen"
                id="screen"
                onChange={(e) => {
                  InterviewStore.setAdditionalSettings(
                    "screen",
                    e.target.checked
                  );
                }}
              />
              <span className="slider round"></span>
            </label>
          </span>
        </div>
      )}
    </div>
  );
}

function CustomQuestionForm() {
  const { InterviewStore } = useStores();
  const [questions, setQuestions] = useState([]);

  const handleAddQuestion = () => {
    setQuestions([...questions, ""]);
  };

  const handleRemoveQuestion = (index) => {
    setQuestions(questions.filter((_, i) => i !== index));
  };

  const handleQuestionChange = (index, value) => {
    const newQuestions = [...questions];
    newQuestions[index] = value;
    setQuestions(newQuestions);
    console.log(newQuestions);
  };

  useEffect(() => {
    InterviewStore.setCustomQuestions(questions);
  }, [questions]);

  return (
    <Observer>
      {() => (
        <>
          <div className="flex justify-between items-center px-2 pr-5 ">
            <p className="block mb-2  w-full font-medium ml-0">
              Add custom questions
            </p>
            <IoInformationCircleOutline className="text-2xl text-primary" />
          </div>

          {questions.map((question, index) => (
            <div key={index} className="mb-4 w-full">
              <div className="flex">
                <input
                  type="text"
                  value={question}
                  onChange={(e) => handleQuestionChange(index, e.target.value)}
                  className="px-2 text-primary border-b-2 border-border2 w-full h-[30px] focus:outline-none "
                  placeholder="Enter your question"
                />
                <MdDeleteOutline
                  onClick={() => handleRemoveQuestion(index)}
                  className="text-xl cursor-pointer mt-1 ml-2 text-text_color5"
                />
              </div>
            </div>
          ))}
          <button
            onClick={handleAddQuestion}
            type="button"
            className="text-primary w-full my-3 flex items-center mt-1"
          >
            <FaPlus className="mr-1" />
            {questions.length > 0 ? " Add one more question" : " Add Question"}
          </button>
        </>
      )}
    </Observer>
  );
}

export function MeetingCreationForm({
  showMeeting = false,
  fromCompany,
  takeInterview = true,
}) {
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;
  const { applicationId } = useParams();
  const [selectedFileName, setSelectedFileName] = useState(null);
  const [selectedFileByUser, setSelectFileByUser] = useState(null);
  const { InterviewStore, PopupStore, RecuiterStore, UserStore } = useStores();
  const inputRef = useRef(null);
  const navigate = useNavigate();
  const studentDetails = JSON.parse(localStorage.getItem("user"));
  const [name, setName] = useState(studentDetails?.name ?? "");
  const [companyurl, setCompanyUrl] = useState("");
  const [technology, setTechnology] = useState("");
  const [restrict, setRestrict] = useState(false);
  const [noOfQuestions, setnoOfQuestions] = useState("5");
  const [level, setLevel] = useState("low");
  const [showMeetingForm, setShowMeetingForm] = useState(showMeeting);
  const [role, setRole] = useState("");
  const [company, setCompany] = useState("");
  const [title, settitle] = useState("");
  const [invitationLink, setInvitationLink] = useState(null);
  const [waiting, setWaiting] = useState(false);
  const [wantToUploadResume, setWantToUploadResume] = useState(true); // this is used to highlight the options
  const [attempts, setAttempts] = useState(-1);
  const [count, setCount] = useState(0);
  const [whoPay, setWhoPay] = useState("company");
  const [load, setLoad] = useState(false);
  const StudentOriginalName = JSON.parse(localStorage.getItem("user"));
  const [showAudioAvatarPopup, setShowAudioAvatarPopup] = useState(false);
  const [resumeError, setResumeError] = useState("");

  const fetchData = async (pdfFile) => {
    try {
      const response = await axios.get(pdfFile, {
        responseType: "arraybuffer",
      });

      const pdfData = response.data; // Directly use response.data as array buffer

      const pdf = await pdfjs.getDocument({ data: pdfData }).promise;
      let fullText = "";

      for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i);
        const content = await page.getTextContent();
        const pageText = content.items.map((item) => item.str).join("\n");
        fullText += pageText + "\n";
      }

      // setExtractedText(fullText);
      console.log(fullText);
      InterviewStore.setResumeText(fullText);
    } catch (error) {
      console.error("Error fetching or parsing PDF file", error);
    }
  };

  useEffect(() => {
    const customSettings = JSON.parse(localStorage.getItem("customSettings"));
    try {
      setAttempts(customSettings[3].value);
    } catch (error) {}
    const presentIteview = JSON.parse(localStorage.getItem("presentIteview"));
    setWhoPay(presentIteview?.whoPay);
  }, []);

  const isIncompleteInterview = (interviews) => {
    return interviews.some((interview) => !interview?.isInterviewCompleted);
  };

  // const [disableForm, setDisableForm] = useState(showMeetingForm);

  const handlechangeName = (e) => {
    setName(e.target.value);
  };
  const handleChangeCompanyUrl = (e) => {
    setCompanyUrl(e.target.value);
  };
  const handlechangeTechnology = (e) => {
    setTechnology(e.target.value);
  };
  // const handleChangeProgrammingLanguages = (e) => {
  //   setTechnology(e.target.value);
  // };
  const handlechangeRole = (e) => {
    setRole(e.target.value);
    console.log(role);
  };
  const handlechangeCompany = (e) => {
    setCompany(e.target.value);
    console.log(company);
  };

  // const handlechangelevel = (e) => {
  //   if (e.target.value === "1") setLevel("low");
  //   else if (e.target.value === "2") setLevel("medium");
  //   else if (e.target.value === "3") setLevel("high");
  //   else setLevel("low");
  // };

  const OpenInterviewScreenBySendingParams = async (e) => {
    e.preventDefault();
    try {
      setLoad(true);
      setResumeError("");
      localStorage.removeItem("career");
      if (!meetingId) {
        localStorage.setItem(
          "Avatar",
          JSON.stringify(InterviewStore.selectedAudio)
        );
      }

      // const nameValid = /^[A-Za-z\s]*$/.test(name);

      // if (!nameValid) {
      //   setLoad(false);
      //   return alert("Name should be in alphabets only.");
      // }

      if (InterviewStore.showResume && InterviewStore.resumeFile === null) {
        setLoad(false);
        setResumeError("Please upload your resume");
        return;
      }

      try {
        function searchNameInResumeText() {
          // Split the name by spaces to get an array of name parts

          const nameParts = name
            .split(" ")
            .filter((part) => part.trim() !== "")
            .map((part) => part.toLowerCase());

          // Check if any of the name parts are included in the InterviewStore.resumeText string
          let isNameFound = true;
          nameParts.forEach((part) => {
            if (!InterviewStore.resumeText.toLowerCase().includes(part)) {
              isNameFound = false;
            }
          });

          console.log(nameParts);

          return isNameFound;
        }
        if (wantToUploadResume) {
          if (InterviewStore.resumeText?.length < 1) {
            alert("Please upload a valid resume");
            setLoad(false);
            return;
          }
          if (!InterviewStore.resumeText) {
            alert("Please upload a valid resume");
            setLoad(false);
            return;
          }
          if (!searchNameInResumeText() && count < 2) {
            console.log(count);
            alert("Your Name in the Resume should match with the entered name");
            setLoad(false);
            return setCount(count + 1);
          }
          if (!searchNameInResumeText() && count === 2)
            if (
              window.confirm(
                "Your Name in the Resume didn't match with the entered name.Do you want to continue any way?"
              )
            ) {
              console.log(count);
            } else {
              return;
            }
        } // Do something with the matched resumes
      } catch (error) {
        setLoad(false);
        console.error("Error processing interview screen parameters:", error);
      }

      const getattempts = () => {
        const customSettings = JSON.parse(
          localStorage.getItem("customSettings")
        );
        let attempts;
        customSettings.map((item) => {
          if (item.name === "attempts") {
            attempts = item.value;
          }
        });
        return attempts;
      };

      let resumeLink = null;

      const userDetails = await getUserDataFromLocalStorage();

      let response = null;
      try {
        const customSettings = JSON.parse(
          localStorage.getItem("customSettings")
        );
        const id = JSON.parse(localStorage.getItem("interviewId"));
        console.log(userDetails);
        console.log(id);
        const numberOfAttempts = getattempts();
        const body = {
          userId: userDetails._id,
          attempts: numberOfAttempts,
          invitationFrom: id,
        };
        console.log(body);

        setAttempts(customSettings[3].value);
        response = await apiPostPut(
          body,
          "/interview/validate-custom-settings2",
          "POST"
        );
        console.log("validation", response);
      } catch (error) {}

      if (localStorage.getItem("user") === null) {
        return PopupStore.setLoginWarning(true);
      }
      if (takeInterview === true) {
        // check resume uploaded or not for resume based interview for user or students
        setWaiting(true);
        const idOfResumeBasedInterviews = [2, 4, 8];
        if (
          idOfResumeBasedInterviews.includes(
            InterviewStore.interviewSettings?.id ??
              InterviewStore.interviewSettings?.interviewId
          )
        ) {
          if (InterviewStore.resumeFile === null && wantToUploadResume) {
            setLoad(false);
            setWaiting(false);
            return alert("Please upload your resume");
          }

          const resumeFileName = Date.now() + InterviewStore.resumeFile?.name;

          const resumeUploadResponse = await uploadFileToAzure(
            resumeFileName,
            InterviewStore.resumeFile,
            { action: "interview" }
          );
          if (resumeUploadResponse?.success) {
            resumeLink = resumeUploadResponse?.url;
          }
        }
        setLoad(false);
        setWaiting(false);
      }

      let interviewDetails = {
        name: name,
        companyurl: companyurl,
        technology:
          InterviewStore.interviewSettings?.title !== "Coding Interview"
            ? technology
            : selectedLanguage,
        levelOfInterview: level === "" ? "low" : level,
        noOfQuestions: noOfQuestions,
        role: role,
        company: company,
        customQuestions: InterviewStore.customQuestions,
        whoPay: InterviewStore.interviewDetails.whoPay,
        // resume: InterviewStore.resumeFile,
        resume: InterviewStore.resumeText,
      };
      if (InterviewStore.companyInterview) {
        interviewDetails.customSettings = [
          {
            name: "video",
            value: InterviewStore.additionalSettings.camera,
          },
          {
            name: "resume",
            value: InterviewStore.additionalSettings.resume,
          },
          {
            name: "screen",
            value: InterviewStore.additionalSettings.screen,
          },
          {
            name: "attempts",
            value: InterviewStore.additionalSettings.attempts,
          },
        ];
        console.log("hello", interviewDetails);
      }
      if (resumeLink !== null) {
        interviewDetails["resumeLink"] = resumeLink;
      }

      console.log(userDetails);
      // return;

      if (takeInterview === false) {
        if (
          userDetails?.role?.role === "company" ||
          userDetails?.role?.role === "consultancy"
        ) {
          // InterviewStore.changeInterviewIdByIdForResume(
          //   InterviewStore.interviewSettings?.id
          // );
          interviewDetails["interviewer"] = userDetails?._id;
          interviewDetails["interviewType"] = "real";
          InterviewStore.updateInterviewDetails(interviewDetails);

          let body = {
            ...InterviewStore.interviewSettings,
            isInvitation: true,
          };

          delete body.id;
          if (RecuiterStore.clientId) {
            body.client = RecuiterStore.clientId;
          }

          console.log(body);

          setWaiting(true);
          setLoad(true);
          const apiResponse = await apiPostPut(
            body,
            "/interview/interview-invitation",
            "POST"
          );
          setWaiting(false);
          setLoad(false);
          console.log(apiResponse);
          if (apiResponse?.body?.success) {
            alert("Invitation sent successfully");

            console.log(apiResponse.body?.data?.interviewLink);
            setInvitationLink(apiResponse.body?.data?.interviewLink);
          } else {
            alert("Something went wrong");
          }

          return;
        }
      }

      // localStorage.setItem("interviewDetails", JSON.stringify(interviewDetails));
      InterviewStore.updateInterviewDetails(interviewDetails);
      console.log(InterviewStore.interviewDetails);
      // navigate(
      //   `/interview?name=${name}&technology=${technology}&level=${level}&question=${noOfQuestions}&id=${InterviewStore.interviewSettings?.id}`
      // );
      // Construct the new URL
      // Step 1: Access the current URL's query string
      const queryString = window.location.search;

      // Step 2: Use URLSearchParams to parse the query string
      const urlParams = new URLSearchParams(queryString);

      // Step 3: Extract the applicationId
      const application = urlParams.get("applicationId");

      // Now you can use applicationId as needed
      console.log(applicationId); // For demonstration

      const newURL = application
        ? `/interview?name=${name}&technology=${
            InterviewStore.interviewSettings?.title !== "Coding Interview"
              ? technology
              : selectedLanguage
          }&level=${level}&question=${noOfQuestions}&id=${
            InterviewStore.interviewSettings?.id
          }&applicationId=${application}&companyurl=${companyurl}`
        : `/interview?name=${name}&technology=${
            InterviewStore.interviewSettings?.title !== "Coding Interview"
              ? technology
              : selectedLanguage
          }&level=${level}&question=${noOfQuestions}&id=${
            InterviewStore.interviewSettings?.id
          }&companyurl=${companyurl}`;
      InterviewStore.setInterviewNavigationLink(newURL);
      // Set the new URL and trigger a reload
      console.log(response);
      console.log(InterviewStore.companyInterview, "companyInterview");

      const user = JSON.parse(localStorage.getItem("user"));
      // alert("hello");
      if (whoPay === "candidate" && user.coins < 179) {
        alert(
          "You don't have enough credits to start the interview, Please Purchase Interview / Credits"
        );
        PopupStore.setGetMoreCredits(true);
        return;
      }

      if (!InterviewStore.validation) {
        window.location.href = newURL;
        return;
      }
      if (whoPay === "candidate") {
        const user = JSON.parse(localStorage.getItem("user"));
        const coins = user?.coins;
        if (coins > 178) {
          // alert("You have to pay for Interview");
        } else {
          const userConfirmed = window.confirm(
            "You have to pay ₹179 for this assessment."
          );

          if (userConfirmed) {
            // If the user clicks "OK"
            return InterviewStore.setWhoPay(true);
          } else {
            // If the user clicks "Cancel"
            return console.log("User chose not to proceed with the payment.");
          }
        }
      }
      if (response?.body?.data?.success) {
        let interviewSettings = JSON.parse(
          localStorage.getItem("interviewSettings")
        ); // Parse the JSON string
        console.log(interviewSettings, "interviewSettings");

        interviewSettings = {
          ...interviewSettings,
          whoPay: whoPay, // Add the whoPay property
        };

        // alert(JSON.stringify(interviewSettings));
        localStorage.setItem(
          "interviewSettings",
          JSON.stringify(interviewSettings)
        );
        // window.location.href = newURL;
        InterviewStore.setInterviewNavigationLink(newURL);
        InterviewStore.setPreviousInterviewsList(response?.body?.data?.data);
        if (!isIncompleteInterview(response?.body?.data?.data)) {
          window.location.href = newURL;
          return;
        }

        if (response?.body?.data?.data?.length > 0) {
          PopupStore.setPreviousInterviews(true);
        } else {
          window.location.href = newURL;
        }
      } else {
        if (localStorage.getItem("user") === null) {
          window.location.href = newURL;
        } else {
          if (!isIncompleteInterview(response?.body?.data?.data)) {
            alert(response?.body?.message);
            return;
          }
          InterviewStore.setInterviewNavigationLink(newURL);
          InterviewStore.setPreviousInterviewsList(response?.body?.data?.data);
          InterviewStore.setAttemptLeft(false);
          if (response?.body?.data?.data?.length > 0) {
            PopupStore.setPreviousInterviews(true);
          }
        }
      }
    } catch (error) {
      setLoad(false);
    }
  };

  const handleModal = () => {
    InterviewStore.setInterviewModal(3);
    // console.log(InterviewStore.interviewModal);
    alert("  ");
    // console.log(JSON.parse(localStorage.getItem("interviewSettings")));
    let interviewSettings = JSON.parse(
      localStorage.getItem("interviewSettings")
    );
    interviewSettings.model = 3;
    // console.log(interviewSettings);
    localStorage.setItem(
      "interviewSettings",
      JSON.stringify(interviewSettings)
    );
  };
  const handleFileChange = (event) => {
    const selectedFile = event.currentTarget.files[0];

    if (selectedFile) {
      InterviewStore.setResumeFile(selectedFile);
      const fileURL = URL.createObjectURL(selectedFile);
      fetchData(fileURL);
      // const { name } = selectedFile;
      // setSelectedFileName(name); // Update the state with the filename
      // setSelectFileByUser(selectedFile);
    }
  };

  const enableFieldByRole = () => {
    const role = getUserRoleFromLocalStorage();
    // alert("hello");

    console.log(role);

    if (role === null) return;

    InterviewStore?.enableInterviewFormById(
      InterviewStore.interviewSettings?.id ??
        InterviewStore?.interviewSettings?.interviewId ??
        JSON.parse(localStorage.getItem("interviewIndex"))?.id ??
        JSON.parse(localStorage.getItem("interviewIndex"))?.interviewId,
      role
    );
    if (localStorage.getItem("interviewIndex")) {
      InterviewStore.setInterviewSettings(
        JSON.parse(localStorage.getItem("interviewIndex"))
      );
    }

    switch (role) {
      case "company":
      case "consultancy":
        console.log(InterviewStore.interviewSettings?.id);
        InterviewStore.setShowCustomQuestions();
        // InterviewStore.changeInterviewIdByIdForResume(
        //   InterviewStore.interviewSettings?.id
        // ); // this will enable resume based interview by default

        break;

      default:
        break;
    }
  };

  // useEffect(() => {
  //   if(!InterviewStore.showNoOfQuestions){
  //     navigate("/dashboard")
  //   }
  // }, [InterviewStore.showName]);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const meetingId = queryParams.get("meetingid");

  const autoFillSomeFields = () => {
    if (meetingId) {
      setRestrict(true);
    }
    // console.log(InterviewStore.interviewSettings)
    // alert("You are not allowed to create a meeting");

    setnoOfQuestions(
      InterviewStore.interviewSettings?.noOfQuestions ?? noOfQuestions
    );
    setLevel(InterviewStore.interviewSettings?.levelOfInterview ?? level);
    setTechnology(
      InterviewStore.interviewSettings?.technology ??
        (InterviewStore.interviewSettings?.title !== "Coding Interview"
          ? technology
          : selectedLanguage)
    );
  };

  const consoleMobxFields = () => {
    console.log(InterviewStore.showTechnology);
    console.log(InterviewStore.showName);
    console.log(InterviewStore.showInterviewLevel);
    console.log(InterviewStore.showNoOfQuestions);
  };

  useEffect(() => {
    console.log(
      "form opened 💥",
      InterviewStore.interviewSettings?.interviewId
    );
    // alert("Interview ID: " + InterviewStore.interviewSettings?.interviewId);

    enableFieldByRole();
    autoFillSomeFields();
    consoleMobxFields(); // remove this later

    return () => {
      InterviewStore.resetInterviewFields();
    };
  }, []);

  useEffect(() => {
    console.log("Selected file name:", selectedFileName);
    console.log(selectedFileByUser);
  }, [selectedFileName]); // This effect runs when selectedFileName changes

  const attachResume = (value) => {
    setWantToUploadResume(value);
    InterviewStore.setShowResume(value);
    InterviewStore.changeInterviewIdByIdForResume(
      InterviewStore.interviewSettings?.id
    );
  };
  const handleCopyClick = () => {
    // Create a textarea element to temporarily hold the text
    const textarea = document.createElement("textarea");
    textarea.value = invitationLink;

    // Append the textarea to the document
    document.body.appendChild(textarea);

    // Select the text in the textarea and copy it to the clipboard
    textarea.select();
    document.execCommand("copy");

    // Remove the textarea from the document
    document.body.removeChild(textarea);
    window.alert("link copied");
  };

  const getInterviewDescription = () => {
    const interviewId = InterviewStore.interviewSettings?.interviewId;
    if (interviewId < 10) {
      const interview = interviewsList.find(
        (interview) => interview?.id === interviewId
      );
      if (interview) {
        autoFillSomeFields();

        settitle(interview?.title);
        return interview?.description;
      }
    } else {
      const prointerview = interviewsProList.find(
        (interview) => interview?.id === interviewId
      );
      if (prointerview) {
        settitle(prointerview?.title);
        return prointerview?.description;
      }
    }
  };
  const handleCompanyInterview = () => {
    if (fromCompany) {
      navigate("/company/interview");
    } else {
      PopupStore.setCreateInterview(true);
    }
  };
  const redirectToSignupPageWithCurrentUrl = () => {
    const currentPath = window.location.href;

    // set currentPath in local storage
    setDataToLocalStorage("redirectUrl", currentPath);

    const signupUrl = `/`;

    console.log(signupUrl);

    navigate(signupUrl);
  };

  const userRole = JSON.parse(localStorage.getItem("user"))?.role?.role;

  const programmingLanguages = [
    { value: "C", label: "C" },
    { value: "C++", label: "C++" },
    { value: "Java", label: "Java" },
    { value: "Python", label: "Python" },
    { value: "Python3", label: "Python3" },
    { value: "C#", label: "C#" },
    { value: "JavaScript", label: "JavaScript" },
    { value: "Ruby", label: "Ruby" },
    { value: "Bash", label: "Bash" },
    { value: "Swift", label: "Swift" },
    { value: "Golang", label: "Golang" },
    { value: "Scala", label: "Scala" },
    { value: "Kotlin", label: "Kotlin" },
    { value: "Rust", label: "Rust" },
    { value: "PHP", label: "PHP" },
    { value: "TypeScript", label: "TypeScript" },
    { value: "Racket", label: "Racket" },
  ];

  const [selectedLanguage, setSelectedLanguage] = useState("");

  const handleChange = (event) => {
    setSelectedLanguage(event.target.value);
  };

  return (
    <Observer>
      {() => (
        <div>
          {showAudioAvatarPopup && (
            <div
              onClick={(e) => setShowAudioAvatarPopup(false)}
              className="fixed  z-50 top-0    w-screen h-screen bg-black  bg-opacity-50 flex justify-center items-center"
            >
              <div
                onClick={(e) => e.stopPropagation()}
                className="bg-white relative   md:ml-[50%] lg:mr-72  rounded-xl px-6  flex flex-col justify-center items-center p-3"
              >
                <AiOutlineCloseCircle
                  className="text-primary absolute text-2xl cursor-pointer top-2 right-2"
                  onClick={() => setShowAudioAvatarPopup(false)}
                />
                <InterviewSetting2 />
                <button
                  onClick={(e) => setShowAudioAvatarPopup(false)}
                  className="bg-primary text-white rounded-xl px-5 py-2 ml-auto my-3"
                >
                  Confirm
                </button>
              </div>
            </div>
          )}

          <PreviousInterviews />
          {PopupStore.getMoreCredits && (
            <GetMoreCreditsPopUp
              popUpInitialValue={PopupStore.getMoreCredits}
              handlePopup={() => {
                PopupStore.setGetMoreCredits(false);
              }}
            />
          )}
          {PopupStore.loginWarning && (
            <Popup
              popUpInitialValue={PopupStore.loginWarning}
              handlePopup={() => {
                PopupStore.setLoginWarning(false);
              }}
              image={loginWarningImage}
              content="Please signup to start interview"
              buttontext="Signup now"
              onClick={() => {
                redirectToSignupPageWithCurrentUrl();
                PopupStore.setLoginWarning(false);
              }}
            />
          )}
          <GetMoreCreditsPopUp
            popUpInitialValue={InterviewStore.whoPay}
            handlePopup={() => {
              InterviewStore.setWhoPay(false);
            }}
            whoPay={true}
          />
          {PopupStore.redeemCoupon && (
            <RedeemCoupon
              popUpInitialValue={true}
              handlePopup={() => {
                PopupStore.setRedeemCoupon(false);
              }}
            />
          )}

          {PopupStore.paymentGateway && (
            <PurchaseCredits
              gateWay="phonePe"
              onClose={() => {
                PopupStore.setPaymentGateway(false);
              }}
            />
          )}
          {
            true ? (
              <div
                className={`bg-[#FFFBF9]  flex flex-col  w-screen min-h-screen   justify-center   transition-transform duration-1000 ease-in-out overflow-y-hidden overflow-x-hidden `}
              >
                {" "}
                <div className=" flex flex-col md:flex-row lg:flex-row h-screen overflow-hidden  justify-around">
                  <div className=" bg-black relative overflow-hidden md:flex   md:pt-10 lg:pt-10 pt-6  md:p-0 md:h-screen overflow-y-hidden lg:min-h-[100vh]  flex-col w-[100%] md:min-w-[50vw] lg:w-[70%]  lg:block hidden">
                    <p
                      className=" md:flex lg:flex hidden items-center   text-primary font-semibold gap-2 text-xl md:text-3xl  cursor-pointer absolute  md:left-[5%] top-[6%] left-52 md:top-[6%] lg:top-[7%] "
                      onClick={() => {
                        setShowMeetingForm(false);
                        PopupStore.setTopicBasedInterview(false);
                        if (userRole === "company") {
                          navigate(-1);
                        } else {
                          if (localStorage.getItem("location")) {
                            navigate(localStorage.getItem("location"));
                            return localStorage.removeItem("location");
                          }
                          navigate("/dashboard/dashboard");
                        }
                      }}
                    >
                      <IoMdArrowRoundBack />
                      Back
                    </p>
                    <h1 className="text-2xl text-white md:text-4xl font-extrabold md:mt-24 lg:mt-40 leading-[50px] mt-5 pl-[5%] p-2">
                      Create a <br />
                      <span className="text-primary mt-0">
                        {InterviewStore.interviewSettings?.title ?? title}{" "}
                      </span>
                      {/* Interview Session */}
                    </h1>
                    <p className="text-[#9B9292] text-base md:text-xl mt-3 md:mt-6 pl-[5%] p-2 pr-5 mb-24">
                      {getInterviewDescription()}{" "}
                    </p>
                    {/* <img
                      src={aiDemoIcon}
                      className=" text-white absolute md:-bottom-[13%] md:-left-[10%] lg:-bottom-[13%] lg:-left-[10%] -left-[14%] -bottom-[10%]"
                      alt="aiDemoIcon"
                    /> */}
                    <div className="absolute md:w-[82%]  -bottom-5">
                      <img
                        src={BgaiDemoIcon}
                        className="w-full md:h-fit lg:h-fit min-h-[25vh] tc6:h-[35vh] tc8:h-[25vh] -mb-[20%] "
                        alt=""
                      />
                      <img
                        src={aiDemoIcon}
                        className="absolute bottom-2 z-10 w-[50%] left-0"
                        alt=""
                      />
                    </div>
                  </div>
                  <form
                    className={`flex flex-col ${
                      InterviewStore.interviewSettings?.title !==
                      "Company Interview with Resume"
                        ? "justify-center tc8:pt-52 tc3:pt-48 tc4:pt-0"
                        : ""
                    } items-center relative md:min-w-[50vw] pt-14 md:pt-0 lg:w-[40%] my-1 lg:ml-0 md:ml-0 ml-4 py-3 h-screen overflow-y-auto`}
                    onSubmit={OpenInterviewScreenBySendingParams}
                  >
                    <h1 className=" md:hidden text-xl text-white md:text-4xl font-extrabold    p-2">
                      <span className="text-primary mt-0 ">
                        Create a{" "}
                        {InterviewStore.interviewSettings?.title ?? title}{" "}
                      </span>
                      {/* Interview Session */}
                    </h1>
                    <p
                      className=" hidden lg:hidden  -mt-16   items-center   text-primary font-semibold gap-2 text-xl md:text-3xl  cursor-pointer absolute  md:left-[5%] top-[6%] left-52 md:top-[6%] lg:top-[7%] "
                      onClick={() => {
                        setShowMeetingForm(false);
                        PopupStore.setTopicBasedInterview(false);
                        if (userRole === "company") {
                          navigate(-1);
                        } else {
                          if (localStorage.getItem("location")) {
                            navigate(localStorage.getItem("location"));
                            return localStorage.removeItem("location");
                          }
                          navigate("/dashboard/dashboard");
                        }
                      }}
                    >
                      <IoMdArrowRoundBack />
                      Back
                    </p>
                    {/* <h1 className="text-center text-primary text-[30px]">Interview Creation</h1> */}
                    {/* <div className="mr-2 ml-auto ">
            <div className="w-6 h-6 text-lg text-bg3 m-auto cursor-pointer  rounded-full  bg-primary" >
              <p className="flex justify-center items-center  m-auto"><span className="m-auto">x</span></p>
            </div>s
          </div> */}
                    {InterviewStore.showName && (
                      <div className="mb-2 w-full md:w-[70%] lg:w-[65%] mt-2  ">
                        <label
                          htmlFor="name"
                          className="block mb-1 md:mt-2 ml-2 font-medium md:text-base lg:text-lg"
                        >
                          Candidate Name*
                        </label>
                        <input
                          type="text"
                          id="name"
                          name="name"
                          placeholder="Sekhar javvadi"
                          required
                          defaultValue={name}
                          onChange={handlechangeName}
                          className="px-5 py-2 text-primary rounded-xl border border-primary w-[90%] h-[45px] md:h-[50px] md:text-lg lg:text-xl focus:outline-none focus:ring-2 focus:ring-primary/20"
                        />
                      </div>
                    )}
                    {InterviewStore.showTechnology && (
                      <div
                        className={`mb-2 w-full md:w-[70%] lg:w-[65%] ${
                          InterviewStore.maskingFields.includes("technology")
                            ? "pointer-events-none"
                            : ""
                        }`}
                      >
                        {InterviewStore.interviewSettings?.title !==
                        "Coding Interview" ? (
                          <>
                            <label
                              htmlFor="technology"
                              className="block mb-1 md:mt-2 ml-2 font-medium md:text-base lg:text-lg"
                            >
                              Technology (Topic of Interview)*
                            </label>
                            <input
                              type="text"
                              id="technology"
                              required
                              name="technology"
                              value={technology}
                              onChange={handlechangeTechnology}
                              placeholder="e.g. Social Media Manager"
                              className=" px-5 py-5 text-primary rounded-xl border border-primary w-[90%] h-[40px] md:h-[45px] md:text-lg lg:text-xl focus:outline-none "
                            />
                          </>
                        ) : (
                          <>
                            <label
                              htmlFor="technology"
                              className="block mb-1 md:mt-2 ml-2 font-medium md:text-base lg:text-lg"
                            >
                              Topic of Interview (Technology)*
                            </label>
                            <select
                              id="language"
                              value={selectedLanguage}
                              onChange={handleChange}
                              className="px-5 text-primary rounded-xl border border-primary w-[90%] h-[40px] md:h-[45px] md:text-lg lg:text-xl focus:outline-none "
                            >
                              <option value="">Select Language</option>{" "}
                              {/* Default option */}
                              {programmingLanguages.map((language) => (
                                <option
                                  key={language}
                                  value={language.value}
                                  // onChange={handleChangeProgrammingLanguages}
                                >
                                  {language.label}
                                </option>
                              ))}
                            </select>
                          </>
                          // <SelectWithDropDown
                          //   options={programmingLanguages}
                          //   action={handleChange}
                          //   label={"Topic of Interview (Technology)*"}
                          //   placeholder={"Select Language"}
                          //   isLanguage={true}
                          //   height={"h-[40px] w-[90%] md:h-[45px]"}
                          //   // className="px-5 py-5 text-primary rounded-xl border border-primary w-[95%] h-[40px] md:h-[45px] md:text-lg lg:text-xl focus:outline-none"
                          // />
                        )}

                        {/* {selectedLanguage && <p>You selected: {selectedLanguage}</p>} */}
                      </div>
                    )}
                    {InterviewStore.showNoOfQuestions && (
                      <div
                        className={`mb-2 w-full md:w-[70%] lg:w-[65%] ${
                          InterviewStore.maskingFields.includes("noOfQuestions")
                            ? "pointer-events-none"
                            : ""
                        }`}
                      >
                        <label
                          htmlFor="technology"
                          className="block mb-1 md:mt-2 ml-2 font-medium md:text-base lg:text-lg"
                        >
                          Select no. of Questions
                        </label>
                        {!restrict ? (
                          <select
                            className="px-5 py-2 rounded-xl !w-[90%] h-[45px] md:h-[50px] md:text-lg lg:text-xl text-primary border border-primary focus:outline-none focus:ring-2 focus:ring-primary/20"
                            value={noOfQuestions}
                            onChange={(e) => setnoOfQuestions(e.target.value)}
                          >
                            <option defaultChecked={true} value={5}>
                              5 Questions
                            </option>
                            <option value={10}>10 Questions</option>
                            {Number(noOfQuestions) !== 5 &&
                              Number(noOfQuestions) !== 10 && (
                                <option value={noOfQuestions}>
                                  {" "}
                                  {noOfQuestions} Questions
                                </option>
                              )}
                          </select>
                        ) : (
                          <input
                            type="text"
                            value={noOfQuestions + " Questions"}
                            className="px-5 py-5 text-primary rounded-xl border border-primary w-[90%] h-[40px] md:h-[45px] md:text-lg lg:text-xl focus:outline-none"
                          />
                        )}
                      </div>
                    )}
                    {InterviewStore.showCompany || InterviewStore.showRole ? (
                      <>
                        {InterviewStore.showCompany && (
                          <div className="mb-2 w-full md:w-[70%] lg:w-[65%]">
                            <label
                              htmlFor="name"
                              className="block mb-1 md:mt-2 ml-2 font-medium md:text-base lg:text-lg"
                            >
                              Company
                            </label>
                            <input
                              onChange={handlechangeCompany}
                              required
                              type="text"
                              id="name"
                              name="name"
                              className="px-5 py-5 text-primary rounded-xl border border-primary w-[90%] h-[40px] md:h-[45px] md:text-lg lg:text-xl focus:outline-none"
                            />
                          </div>
                        )}
                        {InterviewStore.showCompany && (
                          <div className="mb-2 w-full md:w-[70%] lg:w-[65%]">
                            <label
                              htmlFor="name"
                              className="block mb-1 md:mt-2 ml-2 font-medium md:text-base lg:text-lg"
                            >
                              Company Url
                            </label>
                            <input
                              onChange={handleChangeCompanyUrl}
                              required
                              type="text"
                              id="name"
                              name="name"
                              className="px-5 py-5 text-primary rounded-xl border border-primary w-[90%] h-[40px] md:h-[45px] md:text-lg lg:text-xl focus:outline-none"
                            />
                          </div>
                        )}
                        {InterviewStore.showRole && (
                          <div className="mb-2 w-full md:w-[70%] lg:w-[65%]">
                            <label
                              htmlFor="name"
                              className="block mb-1 md:mt-2 ml-2 font-medium md:text-base lg:text-lg"
                            >
                              Role
                            </label>
                            <input
                              onChange={handlechangeRole}
                              required
                              type="text"
                              id="name"
                              name="name"
                              className="px-5 py-5 text-primary rounded-xl border border-primary w-[90%] h-[40px] md:h-[45px] md:text-lg lg:text-xl focus:outline-none"
                            />
                          </div>
                        )}
                      </>
                    ) : null}
                    {/* {InterviewStore.interviewSettings.id === 4 ? (
                  <div>
                    <div>
                      <div className="mb-4">
                        <label
                          htmlFor="name"
                          className="block  font-medium"
                        >
                          Company
                        </label>
                        <input
                          required
                          type="text"
                          id="name"
                          name="name"
                          onChange={handlechangeCompany}
                          className="px-2 text-primary border-b-2 border-border2  h-[30px] w-[300px] md:w-[300px] lg:w-[500px] focus:outline-none "
                        />
                      </div>
                    </div>
                    <div>
                      <div className="mb-4">
                        <label
                          htmlFor="name"
                          className="block  font-medium"
                        >
                          Role
                        </label>
                        <input
                          required
                          type="text"
                          id="name"
                          name="name"
                          onChange={handlechangeRole}
                          className="px-2 text-primary border-b-2 border-border2  h-[30px] w-[300px] md:w-[300px] lg:w-[500px] focus:outline-none "
                        />
                      </div>
                    </div>
                    <div className="flex flex-col items-center justify-center space-x-4">
                      <input
                        id="fileInput"
                        type="file"
                        className="hidden"
                        onChange={handleFileChange}
                      />
                      <label
                        htmlFor="fileInput"
                        className="px-4 py-2 w-full flex justify-center items-center gap-3 text-center bg-primary text-white rounded-md cursor-pointer hover:bg-[#e67f34] transition duration-300 ease-in-out"
                      >
                        <MdFileUpload /> Upload Resume
                      </label>
                      <div className="flex flex-row w-full justify-between">
                        <p className="text-blue-500">
                          {InterviewStore.resumeFile?.name}
                        </p>
                        <p className="text-blue-500 cursor-pointer">Change</p>
                      </div>
                    </div>{" "}
                  </div>
                ) : null} */}
                    {InterviewStore.showInterviewLevel && (
                      <div
                        className={`mb-2 w-full md:w-[70%] lg:w-[65%] ${
                          InterviewStore.maskingFields.includes(
                            "interviewLevel"
                          )
                            ? "pointer-events-none"
                            : ""
                        }`}
                      >
                        <label
                          htmlFor="level"
                          className="block mt-2 mb-1 ml-2 font-medium md:text-base lg:text-lg"
                          onDoubleClick={handleModal}
                        >
                          Select level of Interview
                        </label>
                        {!restrict ? (
                          <select
                            className=" px-5 py-2 rounded-xl w-[90%] h-[45px] md:h-[50px] md:text-lg lg:text-xl text-primary border  border-primary  focus:outline-none "
                            value={level}
                            onChange={(e) => setLevel(e.target.value)}
                          >
                            <option defaultChecked={true} value="low">
                              Low
                            </option>
                            <option value="medium">Medium</option>
                            <option value="high">High</option>
                          </select>
                        ) : (
                          <input
                            type="text"
                            value={level}
                            className="px-5 py-5 text-primary rounded-xl border border-primary w-[90%] h-[40px] md:h-[45px] md:text-lg lg:text-xl focus:outline-none"
                          />
                        )}

                        {/* <div className="flex flex-row w-full">
                          <button
                            type="button"
                            className={`${level === "low"
                              ? "bg-primary text-bg3"
                              : "bg-primary2 text-text_color3"
                              } w-[80px] px-5 py-2 rounded-[10.49px] text-center `}
                            onClick={() => setLevel("low")}
                          >
                            Low
                          </button>
                          <button
                            type="button"
                            className={`${level === "medium"
                              ? "bg-primary text-bg3"
                              : "bg-primary2 text-text_color3"
                              } w-[80px] px-2 py-2 rounded-[10.49px] ml-5 text-center`}
                            onClick={() => setLevel("medium")}
                          >
                            Medium
                          </button>

                          <button
                            type="button"
                            onClick={() => setLevel("high")}
                            className={`${level === "high"
                              ? "bg-primary text-bg3"
                              : "bg-primary2 text-text_color3"
                              } w-[80px] px-5 py-2 rounded-[10.49px] ml-5 text-center`}
                          >
                            High
                          </button>
                        </div> */}
                      </div>
                    )}
                    {InterviewStore.companyInterview && (
                      <div
                        className={`mb-2 w-full md:w-[70%] lg:w-[65%] ${
                          InterviewStore.maskingFields.includes("technology")
                            ? "pointer-events-none"
                            : ""
                        }`}
                      >
                        <label
                          htmlFor="technology"
                          className="block mb-1 md:mt-2 ml-2 font-medium md:text-base lg:text-lg"
                        >
                          No. of Attempts
                        </label>
                        <input
                          type="number"
                          id="technology"
                          required
                          name="technology"
                          value={InterviewStore.additionalSettings.attempts}
                          onChange={(e) => {
                            InterviewStore.setAdditionalSettings(
                              "attempts",
                              Number(e.target.value)
                            );
                          }}
                          className=" px-5 py-5 text-primary rounded-xl border border-primary w-[90%] h-[40px] md:h-[45px] md:text-lg lg:text-xl focus:outline-none "
                        />
                      </div>
                    )}
                    {InterviewStore.companyInterview && (
                      <div className=" mb-2 w-full md:w-[70%] lg:w-[65%]">
                        <AdditionalSettings />
                      </div>
                    )}
                    {InterviewStore.showCustomQuestions &&
                    InterviewStore.companyInterview ? (
                      <div className=" mb-2 w-full md:w-[70%] lg:w-[65%]">
                        <CustomQuestionForm />
                      </div>
                    ) : null}
                    {invitationLink !== null && (
                      <div className="w-full md:w-[70%] lg:w-[65%] mb-4">
                        <label className="block mb-1 md:mt-2 ml-2 font-medium md:text-base lg:text-lg">
                          Invitation Link
                        </label>
                        <div className="relative">
                          <textarea
                            className="w-full h-[100px] px-4 py-3 text-primary rounded-xl border border-primary focus:outline-none focus:ring-2 focus:ring-primary/20 resize-none"
                            value={invitationLink}
                            readOnly
                          />
                          <button
                            onClick={handleCopyClick}
                            className="absolute top-3 right-3 p-2 text-gray-600 hover:text-primary transition-colors duration-200"
                            title="Copy link"
                          >
                            <AiOutlineCopy className="text-xl" />
                          </button>
                        </div>
                      </div>
                    )}
                    {!meetingId && (
                      <div className="mb-2 w-full md:w-[70%] lg:w-[65%]">
                        <label
                          htmlFor="name"
                          className="block mb-1 md:mt-2 ml-2 font-medium md:text-base lg:text-lg"
                        >
                          Select your Audio & Avatar
                        </label>
                        <div
                          onClick={() => setShowAudioAvatarPopup(true)}
                          className="px-5 items-center flex cursor-pointer text-primary rounded-xl border border-primary w-[90%] h-[45px] md:h-[50px] md:text-lg lg:text-xl focus:outline-none hover:bg-primary/5 transition-colors duration-200"
                        >
                          {InterviewStore.selectedAudio ? (
                            <div className="flex items-center relative justify-between w-full">
                              <div className="flex items-center gap-4">
                                <img
                                  src={InterviewStore.selectedAudio.image}
                                  alt=""
                                  className="w-8 h-8 rounded-full object-cover"
                                />
                                <div className="flex flex-col">
                                  <h1 className="font-medium">
                                    {InterviewStore.selectedAudio.label} {InterviewStore.selectedAudio.country}
                                  </h1>
                                  <p className="text-sm text-gray-500">
                                    {InterviewStore.selectedAudio.gender}
                                  </p>
                                </div>
                              </div>
                              <AiFillCaretDown className="text-primary" />
                            </div>
                          ) : (
                            <div className="flex items-center justify-between w-full">
                              <span className="text-gray-500">Select Audio & Avatar</span>
                              <AiFillCaretDown className="text-primary" />
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                    {InterviewStore.askHaveResume &&
                      InterviewStore.ResumeCompanyInterview && (
                        <div
                          className={`mb-1 md:mt-2 w-[100%] pr-5 gap-2 flex flex-row items-center justify-between md:w-[70%] lg:w-[65%] ${
                            InterviewStore.maskingFields.includes(
                              "askHaveResume"
                            )
                              ? ""
                              : ""
                          }`}
                        >
                          <label
                            htmlFor="level"
                            className="block text-center items-center md:ml-2 whitespace-nowrap font-medium md:text-base lg:text-lg"
                            // onDoubleClick={handleModal}
                          >
                            Do you have a Resume?
                          </label>

                          <div className="flex gap-2 md:gap-4 items-center mr-10">
                            <label
                              className={`radio-label flex items-center gap-2 cursor-pointer ${
                                wantToUploadResume === true ? "text-primary" : "text-gray-600"
                              }`}
                            >
                              <input
                                type="radio"
                                className="w-4 h-4 text-primary border-gray-300 focus:ring-primary cursor-pointer"
                                value="Yes"
                                checked={wantToUploadResume === true}
                                onChange={() => attachResume(true)}
                              />
                              <span className="md:text-base">Yes</span>
                            </label>
                            <label
                              className={`radio-label flex items-center gap-2 cursor-pointer ${
                                wantToUploadResume === false ? "text-primary" : "text-gray-600"
                              }`}
                            >
                              <input
                                type="radio"
                                className="w-4 h-4 text-primary border-gray-300 focus:ring-primary cursor-pointer"
                                value="No"
                                checked={wantToUploadResume === false}
                                onChange={() => attachResume(false)}
                              />
                              <span className="md:text-base">No</span>
                            </label>
                          </div>
                        </div>
                      )}
                    {InterviewStore.showResume ? (
                      <div className="my-2 w-full md:w-[70%] lg:w-[65%]">
                        <div className="flex flex-col">
                          <input
                            id="fileInput"
                            type="file"
                            className="hidden"
                            onChange={handleFileChange}
                            accept=".pdf"
                          />
                          <label
                            htmlFor="fileInput"
                            className={`px-4 py-2 w-fit min-w-[90%] text-center flex items-center border ${
                              resumeError ? "border-red-500" : "border-primary"
                            } rounded-xl cursor-pointer transition duration-300 ease-in-out hover:bg-primary/5 ${
                              InterviewStore.showResume ? "gap-2" : "gap-3"
                            }`}
                          >
                            <p className="font-semibold text-sm truncate">
                              {InterviewStore.resumeFile?.name || "Upload Resume"}
                            </p>
                            <div className="flex items-center h-[35px] md:text-lg lg:text-xl">
                              <MdFileUpload className={`text-2xl ${resumeError ? "text-red-500" : "text-primary"}`} />
                            </div>
                          </label>
                          {resumeError && (
                            <p className="text-red-500 text-sm mt-1 ml-1">{resumeError}</p>
                          )}
                        </div>
                      </div>
                    ) : null}

                    {/* <div className="opacity-600 mb-2 text-[0.8rem] w-[100%] flex flex-row font-semibold items-center text-text_color3">
                    <AiOutlineInfoCircle className="mx-2 text-[1rem]" />
                    <p>100 credits will be deducted for each interview</p>
                    </div> */}

                    {/* {attempts !== -1 &&  (
                      <div className="mb-2 w-full md:w-[70%] lg:w-[65%]">
                        <p className=" text-lg">
                          You can attempt{" "}
                          <span className="text-primary text-lg font-bold">
                            {attempts} times
                          </span>{" "}
                          only
                        </p>
                      </div>
                    )} */}
                    {JSON.parse(localStorage.getItem("interviewDetails"))
                      ?.interviewType === "real" && (
                      <div className="w-full">
                        <button
                          className={`text-primary  underline text-lg w-[95%] md:w-[56%] lg:w-[65%]   h-[40px] `}
                          onClick={() => {
                            InterviewStore.setAdditionalSettings(
                              "camera",
                              false
                            );
                            InterviewStore.setAdditionalSettings(
                              "resume",
                              false
                            );
                            InterviewStore.setAdditionalSettings(
                              "screen",
                              false
                            );
                            InterviewStore.setAdditionalSettings("attempts", 2);
                            setShowMeetingForm(false);
                            PopupStore.setTopicBasedInterview(false);
                            navigate("/dashboard/dashboard");
                          }}
                        >
                          Practice Interview
                        </button>
                      </div>
                    )}
                    <div className=" w-full md:w-[70%] lg:w-[65%]">
                      <button
                        type="submit"
                        className={`text-bg3 ${
                          invitationLink ? "hidden" : "block"
                        } flex flex-row justify-center items-center text-center my-3 text-[18px] font-bold px-3 rounded-2xl h-[60px] bg-primary w-[90%] gap-2 mb-16 hover:bg-primary/90 transition-colors duration-200`}
                      >
                        {load ? (
                          <FaCircleNotch className="text-primary2 animate-spin text-3xl" />
                        ) : (
                          <span className="text-[30px] text-white text-center w-8 h-8 flex items-center justify-center rounded-full border-2 border-white ">
                            <MdOutlineAdd />
                          </span>
                        )}
                        <p className="ml-2">
                          {load ? "loading.." : "New Interview"}
                        </p>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            ) : null
            // <button
            //   onClick={() => setShowMeetingForm(true)}
            //   className=" md-agent-shadoww text-primary2 flex flex-row justify-center md:ml-5 items-center text-center text-[17px]  m-auto px-3  rounded-lg h-[60px] bg-primary w-[100%] lg:w-[95%] md:w-[95%] "
            // >
            //   <span className="text-[30px] text-primary2 ml-5 text-center w-8 h-8 flex items-center justify-center rounded-full bg-primary border border-white ">
            //     <MdOutlineAdd />
            //   </span>{" "}
            //   <p className="ml-5">Create Interview Session</p>
            // </button>
          }
          {/* <div>
            {!PopupStore.topicbasedinterview ? (
              <button
                onClick={() => PopupStore.setCreateInterview(true)}
                className=" text-primary flex flex-row justify-center mt-2 md:ml-5 items-center text-center text-[17px] m-auto px-3 rounded-full h-[60px] lg:text-3xl lg:p-6 lg:py-10   md:bg-white lg:bg-white md:border-2 lg:border-2 border-primary  w-[100%] lg:w-[95%] md:w-[95%] transition-colors duration-300 hover:bg-primary hover:text-white "
              >
                {waiting ? (
                  <FaCircleNotch className=" animate-spin text-3xl" />
                ) : (
                  <span className="text-[30px]  text-center w-8 h-8 flex items-center justify-center rounded-full ">
                    <IoAddCircleOutline />
                  </span>
                )}
                <p className="ml-2 gil-med">Create An Interview</p>
              </button>
            ) : null}

            {/* <ReferAndEarnCard /> */}
          {/* </div> */}
          <div>
            {/* {!PopupStore.topicbasedinterview ? (
              <button
                onClick={() => {
                  handleCompanyInterview();
                  // PopupStore.setCreateInterview(true);
                }}
                className=" text-primary flex flex-row justify-center mt-2 md:ml-5 items-center text-center text-[17px] m-auto px-3 rounded-full h-[60px] lg:text-xl lg:p-6 lg:py-10   md:bg-white lg:bg-white md:border-2 lg:border-2 border-primary  w-[100%] lg:w-[95%] md:w-[95%] transition-colors duration-300 hover:bg-primary hover:text-white "
              >
                {waiting ? (
                  <FaCircleNotch className=" animate-spin text-3xl" />
                ) : (
                  <span className="text-[30px]  text-center w-8 h-8 flex items-center justify-center rounded-full ">
                    <IoAddCircleOutline />
                  </span>
                )}
                <p className="ml-2 gil-med">Create An Interview</p>
              </button>
            ) : null} */}

            {/* <ReferAndEarnCard /> */}
          </div>
        </div>
      )}
    </Observer>
  );
}
